export const p60Constants = {
  GET_REQUEST: 'P60_GET_REQUEST',
  GET_SUCCESS: 'P60_GET_SUCCESS',
  GET_FAILURE: 'P60_GET_FAILURE',
};
